import { Box, Flex } from '@frontend/legacy-components';

import HomeNav from './components/HomeNav';
import NavDropdown from './components/NavDropDown';

export const MicroAppHeader = () => {
  return (
    <Flex bg="brand.primary" minHeight={4} transition="all 0.2s ease">
      <HomeNav isMicroAppHeader={true} />
      <Box height="100%" m="auto 0 auto auto">
        <Box m="auto 0" height="100%">
          <NavDropdown isMicroAppHeader={true} />
        </Box>
      </Box>
    </Flex>
  );
};
